<template>
  <el-select  :size='selectSize' :disabled="disabled" filterable :clearable='clearable' @change="handleChange" :value="data.value" :placeholder="$t('请选择')"
             @clear="handleChange">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in operator" :key="index"></el-option>
  </el-select>
</template>

<script>
    // import {getCascade} from '@/services/deviceType'
    import { getCascade } from "@/services/customer";

    export default {
        name: 'Operator',
        props: {
            value: {},
            disabled: {
                type: Boolean,
                default: false
            },
            clearable:{
                type: Boolean,
                default: true
            },
            selectSize: {
                type: String,
                default: 'medium',
            },
        },

        data() {
            return {data: {}, operator: []}
        },
        watch: {
            value:{
                immediate:true,
                handler(value){
                    if (value) {
                            this.data = value;
                        } else {
                            this.data = {};
                        }

                }
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            setSelectValue(value) {
                this.data = {
                    value: value,
                    name: ""
                }
            },
            handleChange(value) {
                
                let find = this.operator.find((item, i) => {
                    return item.value == value
                })
                if (!find) {
                    find = {};
                }
               
                if (find==undefined) {
                    find = "";
                }
                this.$emit("input", {...find});
                this.$emit("change", {...find});
                this.data = {...find};
            },
            async loadData() {
               
                const response = await getCascade( {});
                // console.log(response,"response")
                if (response&&response.code==0) {
                    this.operator = response.data.factoryList.map((item, i) => {
                        return {name: item.factoryName, value: item.id}
                    })
                }
                this.$emit("handleOperator", this.operator);
            }

        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/operation/Operator.vue